export default "__VITE_ASSET__6f49a640__"